import React from 'react'

import { Icon } from '@/Atomic/Atoms/Icon'
import { Avatar } from '@/Atomic/Molecules/Avatar'
import { DataBinary } from '@/utils/dataBinaryToUrl'

interface HeaderImageProps {
  avatar?: string | DataBinary
  icon?: string
}

export const HeaderImage: React.FC<HeaderImageProps> = ({
  avatar,
  icon = '',
}) => {
  let img = <Avatar avatar={avatar} className="image" />

  if (!avatar && icon) {
    img = <Icon icon={icon} className="icon" />
  }

  return <div className="image-wrapper">{img}</div>
}
